import * as React from 'react';
import { colors, fontFamily } from './styles';
import * as typestyle from 'typestyle';
import * as types from 'typestyle/lib/types';

export enum AlertType {
  Success,
  Info,
  Warning,
  Error,
}

/**
 * https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/molecules/notifications
 */
namespace AlertStyles {
  /** The common stuff between alert types */
  const baseStyles: types.NestedCSSProperties = {
    fontFamily: fontFamily.arial,
    padding: '12px 10px',
    borderRadius: '3px',
    borderWidth: '1px',
    borderStyle: 'solid',
    wordWrap: 'break-word',
  };

  /** The stuff that is different for each alert type */
  interface Colors {
    color: string,
    backgroundColor: string,
    borderColor: string,
    [key: string]: any;
  }

  /** NOTE: some colors aren't in the main colors pallete and exist only for alerts */
  const successColors: Colors = {
    color: colors.success,
    backgroundColor: '#DFF0D8',
    borderColor: '#D1E8CE',
  }
  const infoColors: Colors = {
    color: colors.current,
    backgroundColor: '#E6EFF5',
    borderColor: '#D3E2EB',
  }
  const warningColors: Colors = {
    color: '#8A6D3B',
    backgroundColor: '#FCF8E2',
    borderColor: '#F3EDD5',
  }
  const errorColors: Colors = {
    color: colors.activeRed,
    backgroundColor: '#F2DEDE',
    borderColor: '#F2DEDE',
  }

  /** The class names */
  const success = typestyle.style(baseStyles, successColors)
  const info = typestyle.style(baseStyles, infoColors)
  const warning = typestyle.style(baseStyles, warningColors)
  const error = typestyle.style(baseStyles, errorColors)

  /** Make it easier to lookup className by type */
  export const classNameMap = {
    [AlertType.Success]: success,
    [AlertType.Info]: info,
    [AlertType.Warning]: warning,
    [AlertType.Error]: error,
  };
}

export interface AlertProps {
  type: AlertType;
  id?: string;
  children?: any;
}

export class Alert extends React.Component<AlertProps, {}>{
  render() {
    const {props} = this;
    const className = AlertStyles.classNameMap[props.type];
    return (
      <div className={className} id={props.id}>
        {props.children}
      </div>
    );
  }
}
